import { FunctionComponent } from "react";

type DjehootyLogoProps = {
    size?: number;
    className?: string;
}

/**
 * DjehootyLogo component displays the Djehooty logo.
 * 
 * @param size - The width (in pixels) of the logo. Defaults to 60.
 * @param className - Additional CSS classes for custom styling.
 * 
 */
const DjehootyLogo: FunctionComponent<DjehootyLogoProps> = ({ size = 60, className = "" }) => {
    return (
        <img
            width={size}
            src="/djehooty-logo-transparent.png"
            alt="Black sacred ibis standing in right profile represented in the style of Egyptian hieroglyphics"
            loading="lazy"
            className={`opacity-90 ${className}`}
        />
    )
}

export default DjehootyLogo;